import { Guid } from 'guid-typescript';

export class TaskActivityModel {
  id: Guid;
  activity: string;
  isDefault: boolean;
  description: string;
  activityCode: string;
}
